import React from 'react';
import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ isAuthenticated = false, permission = false, children }) => {
    return isAuthenticated && permission ? <>{children}</> : <Navigate to="/" />;
};

export default PrivateRoute;
